import { WindowService } from '../../shared/services/window.service';

export function pwaServiceWorkerUserIdFactory(windowService: WindowService): () => Promise<string> {
    // Provide a function that will obtain the PWA service worker user ID lazily. This is to ensure that getting the ID doesn't run during app startup
    // Different from service-worker-user-id.factory, PWA can potentially make request for a different user on the same session so we don't keep a
    // singleton promise.
    return () => Promise.resolve(windowService.nativeWindow.pwaCurrentUserId);
}
